import React from "react";
import {withFormik} from "formik";
import GameInstance from "common/models/game-instance";
import assets from "../../../../assets";

class InnerForm extends React.Component {

    locale = 'cs-CZ';

    constructor(params) {
        super(params);
        this.state = {
            opened: false
        }
    }

    selectOption(optionId) {
        this.props.setFieldValue("option_id", optionId);
        this.props.setFieldValue("month", '');
    }

    toggleOpened() {
        this.setState({...this.state, opened: !this.state.opened});
    }

    render() {
        const {answer, values} = this.props;

        let options = this.props.question.options
            .sort((a,b) => { return a.id - b.id })
            .map((option, optionIndex) => {
            let selected = this.props.values.option_id === option.id;
            let itemClass = `question-options__option ${ selected ? 'selected' : ( answer ? 'inactive' : '' ) }`;

            let money_resources = option.properties.resources
                .filter((resource) => GameInstance.MONEY_RESOURCES.includes(resource['type']))
                .map((money, key) => (<div key={key}><span className={money['amount'] < 0 ? 'text-danger' : ''}>{ (money['amount'] > 0 ) ? '+' : '' }{ money['amount'].toLocaleString(this.locale) } <small>Kč{ money['repeat'] ? '/měs' : '' }</small></span> <img src={assets.resources.money_tiny}/></div>));


            return (
                <div key={option.id} className={itemClass} onClick={() => { this.props.active && this.selectOption(option.id) }}>
                    <div className='question-options__option__id'>{ String.fromCharCode(65 + optionIndex) }</div>
                    <div className='question-options__option__text'>
                        { !option.properties.preferred && option.name }
                        { option.properties.preferred && <p>{ option.name }</p> }
                        { option.properties.preferred && <div className='small text-success'>Lidé jako vy obvykle volí tuto možnost</div> }
                    </div>
                    <div className='question-options__option__resources'>{ money_resources }</div>
                </div>
            )
        });

        let selectedOptionId = this.props.values.option_id;
        let selectedOption = this.props.question.options.find((option) => option.id === selectedOptionId);
        let selectedOptionShowMonth = false;

        if (selectedOption) {
            let selectedResources = selectedOption['properties']['resources'].filter((resource) => GameInstance.MONEY_RESOURCES.includes(resource['type']));
            let hasRepeating = selectedResources.find((resource) => resource['repeat']) !== undefined;
            let hasOnetime = selectedResources.find((resource) => !resource['repeat'] && !resource['months']) !== undefined;

            selectedOptionShowMonth = hasOnetime && !hasRepeating;
        }

        let month = false;
        if ( this.props.active && selectedOptionShowMonth ) {
            month = (
                <select className='form-control' name="month" onChange={this.props.handleChange} onBlur={this.props.handleBlur} value={values.month}>
                    <option value="">Zvolte měsíc jednorázového výdaje</option>
                    { Object.keys(this.props.question.properties.availability).map((month) => {
                        return this.props.question.properties.availability[month] && (<option key={month}>{ month }</option>)
                    }) }
                </select>
            )
        } else if ( !this.props.active && answer.properties.month ) {
            month = (<p>{values.month}</p>);
        }

        let btnClass = 'btn ';
        let btnDisabled = true;
        if (answer) {
            if ((values.option_id !== answer.luduengine_knowledge_question_option_id || values.month != answer.properties.month) && ( !month || values.month )) {
                btnClass += 'btn-primary';
                btnDisabled = false;
            } else {
                btnClass += 'btn-secondary';
            }
        } else {
            if (values.option_id !== undefined && ( !month || values.month )) {
                btnClass += 'btn-primary';
                btnDisabled = false;
            } else {
                btnClass += 'btn-secondary';
            }
        }

        return (
            <div className='card task'>
                <form onSubmit={this.props.handleSubmit}>
                    <div className='description'>
                        <div>
                            <img className='task-indicator' src={answer ? assets.task.task_answered : assets.task.task_simple}/>
                        </div>
                        <div className='info'>
                            <h4>{ this.props.question.name }</h4>
                            <div>{ this.props.question.properties.description }</div>
                        </div>
                        <div className='actions'><button type='button' className={`btn btn-${ this.state.opened ? 'outline-primary' : 'primary' }`} onClick={() => { this.toggleOpened(); }}>{ this.state.opened ? 'Skrýt' : 'Zobrazit' }</button></div>
                    </div>
                    <div className={`options ${ this.state.opened ? 'opened' : '' }`}>
                        <ul className='question-options'>
                            { options }
                        </ul>
                        { month &&
                        <div className='form-group'>
                            <label>Měsíc</label>
                            {month}
                        </div>
                        }
                        { this.props.active && <button disabled={btnDisabled} type='submit' className={btnClass}>Uložit odpověď</button> }
                    </div>
                </form>
            </div>

        )
    }
}

const QuestionForm = withFormik({
    mapPropsToValues: props => ({ month: (props.answer ? props.answer.properties.month : undefined), option_id: (props.answer ? props.answer.luduengine_knowledge_question_option_id : undefined ) }),
    validate: () => {},
    handleSubmit: (values, bag) => { bag.props.handleSubmit(values, bag) }
})(InnerForm);

export default QuestionForm;